<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="会员信息">
          <el-input v-model="searchForm.search" placeholder="真实姓名|手机号|身份证"></el-input>
        </el-form-item>
        <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="推广账号"
        v-if="homeshow">
          <el-select size="small" v-model="searchForm.tuiguang_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in shlist" :key="index" :label="item.user_name"
              :value="item.shop_user_id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker size="small" v-model="searchForm.create_time" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button size="small" type="primary" icon="el-icon-search"
            @click="onSubmit">查询</el-button></el-form-item>
        <!-- <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item>
        <el-form-item><el-button size="small" type="info" @click="getshuax">刷新</el-button></el-form-item> -->
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部订单" name="all"></el-tab-pane>
          <el-tab-pane :label="'未付款'" name="payment">
            <span slot="label">未付款 <el-tag size="mini">{{ order_count.payment }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'待审核'" name="examine">
            <span slot="label">待审核 <el-tag size="mini">{{ order_count.examine }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'待发货'" name="delivery">
            <span slot="label">待发货 <el-tag size="mini">{{ order_count.delivery }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'待收货'" name="received">
            <span slot="label">待收货 <el-tag size="mini">{{ order_count.received }}</el-tag></span>
          </el-tab-pane>

          <el-tab-pane :label="'租赁中'" name="haveInHand">
            <span slot="label">租赁中 <el-tag size="mini">{{ order_count.haveInHand }}</el-tag></span>
          </el-tab-pane>
          <!-- <el-tab-pane :label="'已买断'" name="BuyOut">
                <span slot="label">已买断 <el-tag size="mini">{{order_count.BuyOut}}</el-tag></span>
              </el-tab-pane> -->
          <el-tab-pane :label="'待归还'" name="returned">
            <span slot="label">待归还 <el-tag size="mini">{{ order_count.returned }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'归还中'" name="Returning">
            <span slot="label">归还中 <el-tag size="mini">{{ order_count.Returning }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'拒归还'" name="refuse">
            <span slot="label">拒归还 <el-tag size="mini">{{ order_count.refuse }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'已取消'" name="cancel">
            <span slot="label">已取消 <el-tag size="mini">{{ order_count.cancel }}</el-tag></span>
          </el-tab-pane>
          <!-- <el-tab-pane label="待评价" name="comment"></el-tab-pane> -->
          <el-tab-pane label="已完成" name="complete">
            <span slot="label">已完成 <el-tag size="mini">{{ order_count.complete }}</el-tag></span>
          </el-tab-pane>
          <el-tab-pane :label="'已驳回'" name="reject">
            <span slot="label">已驳回 <el-tag size="mini">{{ order_count.reject }}</el-tag></span>
          </el-tab-pane>
        </el-tabs>


        <el-table :data="tableData2.data" style="width: 100%">
          <el-table-column label="订单编号">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.order_no }}</span>
            </template>
          </el-table-column>

          <el-table-column label="渠道名称">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ baseInfo.user.user_name }}</span>
            </template>
          </el-table-column>

          <el-table-column label="商品名称" width="450">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.product[0].product_name }}</span>
            </template>
          </el-table-column>

          <el-table-column label="姓名">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.username ? scope.row.username : "null(未认证)" }}</span>
            </template>
          </el-table-column>

          <el-table-column label="手机号">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.user.mobile }}</span>
            </template>
          </el-table-column>

          <el-table-column label="下单时间">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.create_time }}</span>
            </template>
          </el-table-column>
          <el-table-column label="收货人手机号">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.address.phone }}</span>
            </template>
          </el-table-column>

          <el-table-column label="订单状态">
            <template slot-scope="scope">
              <span style="margin-left: 10px"> {{ scope.row.order_status.value == 40 ? '已驳回' : scope.row.state_text
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-sizes="[10, 20, 50, 100]" :page-size="10"
          layout="total, prev,sizes ,pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
      <!-- 密码弹窗 -->
      <el-dialog title="请输入密码" :visible.sync="dialogVisible10" width="20%">
        <div style="height:100px;">
          <el-input placeholder="请输入密码" v-model="sdinput" show-password></el-input>
          <div style="margin-top:20px;display: flex;justify-content:center;"><el-button type="primary"
              @click="sdqd()">确定</el-button></div>
        </div>
      </el-dialog>


    </div>
    <Shen v-if="shenhe" :open_edit="shenhe" :order_id="order_id" @close="closeShenhe($event, 'edit')"></Shen>
    <Ju v-if="Ju" :open_edit="shenhe" :order_id="order_id" @close="closeShenhe2($event, 'edit')"></Ju>
    <Logistics :logisticsData="logisticsData" :isLogistics="isLogistics" @closeDialog='closeLogistics'> </Logistics>
  </div>
</template>

<script>
import axios from 'axios';
import Shen from './dialog/shenhe.vue';
import Ju from './dialog/Ju.vue';
import OrderApi from '@/api/order.js';
import FengkongApi from '@/api/fengkong.js';
import PorductApi from '@/api/product.js';
import AuthApi from '@/api/auth.js';
import Logistics from '@/components/logistics/viewLogistics.vue'
import qs from 'qs';
import { number } from 'echarts/lib/export';
import { indexOf, isArray } from 'zrender/lib/core/util';
export default {
  components: {
    Logistics,
    Shen,
    Ju
  },
  data() {
    return {
      homeshow:true,
      roleList:"",
      lease_type: "",
      product_attrdata: "",
      sku_iddata: "",
      // 修改商品数据
      catList: '',
      catList2: '',
      catList3: "",
      catList4: "",
      catList5: [],
      spflvalue: "",
      sxspvalue: "",
      sxggvalue: "",
      spggvalue: "",
      Attrvalue: "",
      Attrvalue2: "",
      Attrvalue3: "",
      Attrvalue4: "",
      Attrvalue5: "",
      ggname: "",
      ggname2: "",
      ggname3: "",
      ggname4: "",
      ggname5: "",
      // 修改商品展示
      shr: "",
      shrdh: "",
      prData: "",
      // 三要素
      sysname: "",
      syssjh: "",
      syssfz: "",
      fengxian: '',
      username: '',
      usernum: '',
      mobile: '',
      /*发货*/
      form: {
        /*订单ID*/
        express_id: 10001,
        /*订单号*/
        express_no: '',
        //设备编号
        equipment_no: ''
      },
      /*快递公司列表*/
      expressList: [],
      /*结清*/
      jqform: {
        /*结清金额*/
        value: '',
        /*结清类型*/
        type: ''
      },
      /*结清类型列表*/
      jieqingList: [{
        type: '正常 (0-30天)',
        value: 1
      },
      {
        type: '关注 (31-60天)',
        value: 2
      },
      {
        type: '次级(61-120天)',
        value: 3
      },
      {
        type: '可疑(121天-180天)',
        value: 4
      },
      {
        type: '损失 (180天以上)',
        value: 5
      }],
      jieguo: "",
      inputshsm: "",
      dialogVisibleshsm: false,
      shenhe: false,
      Ju: false,
      inputfkbz: "",
      dialogVisiblefkbz: false,
      inputzcbz: "",
      dialogVisiblezcbz: false,
      sanyaosu: '',
      sanyaosumsg: '',
      dialogTableVisible: false,
      dialogTableVisible1: false,
      fengxianchaxun: false,
      age: "",
      sdinput: "",
      zujin: "",
      shop_url: "",
      htdata: "",
      // 签署id
      folwid: '',
      //碎屏险
      radio: "2",
      // order_id 订单id
      order_id: "",
      remarksText: "",
      remarksText1: "",
      // 输入框值
      yushou: "",
      /*显示弹框*/
      dialogVisiblejq: false,
      dialogVisiblexgsp: false,
      dialogVisiblewlfh: false,
      dialogVisible1: false,
      fengxain1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      dialogVisible10: false,
      // 租期id
      shneheList: [],
      // 租期列表
      zqlist: "",
      /*显示弹框*/
      dialogVisible: false,
      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      tableData2: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        search: '',
        order_no: '',
        style_id: '',
        create_time: '',
        tuiguang_id: ''
      },
      /*配送方式*/
      exStyle: [],
      /*选择商户*/
      shlist: [],
      /*门店列表*/
      shopList: [],
      /*时间*/
      create_time: '',
      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0,
        cancel: 0,
        haveInHand: 0,
        buyOut: 0,
        Returning: 0,
        returned: 0,
        examine: 0,
        refuse: 0
      },
      isLogistics: false,
      logisticsData: {}
    };
  },
  inject: ['baseInfo'],
  created() {
    /*获取列表*/
    this.getData();
    this.gofenpei();
    this.getTableList();
  },
  mounted() {
    window.mobilecheck = this.mobilecheck
  },
  methods: {
     /*获取列表*/
     getTableList() {
      let self = this;
      let Params = {};
      AuthApi.userList(Params, true)
        .then(data => {
          self.roleList = data.data.list.data;
          // console.log("roleList",self.roleList);
          // console.log("baseInfo",self.baseInfo.user.user_name);
          let datainfo = self.roleList;
          for (let item of datainfo) {
            // console.log(item.user_name);
            if (item.user_name == self.baseInfo.user.user_name) {
              // console.log(item.role_id);
              if(item.role_id == 4){
                  self.homeshow = false;
              }else{
                self.homeshow = true
              }
            }
          }
        })
        .catch(error => {});
    },
    gofenpei() {
      OrderApi.authuser({
        role_id: 4
      }, true).then(data => {
        this.shlist = data.data.list.data;
      })
    },
    // 刷新订单
    getshuax() {
      this.getData();
      this.$message({
        message: '刷新订单成功',
        type: 'success'
      });
    },
    // 筛选风控手机号
    remarksSj(str) {
      // console.log(data);
      let newStr = str;//返回值
      const phoneReg = /(1[0-9]{2,10})|([0-9]{3,4})?[0-9]{7,8}|[\d\w]+\b@[a-zA-ZA-z0-9]+.[a-z]+/g;//匹配手机号或者固话,邮箱
      const num = str.replace(/\s|[(]|[)]|[(]|[)]|[-]*/g, "");//去除字符串中所有空格、小括号和横杠
      const phone = num.match(phoneReg);//识别手机号或者固话（在字符串内检索指定的值，或找到一个或多个正则表达式的匹配）
      if (isArray(phone)) {
        phone.forEach(mobile => {
          console.log(mobile)
          var newmobile = '<a onclick="mobilecheck(' + mobile + ')">' + mobile + '</a><br/>'
          newStr = newStr.replace(mobile, newmobile);
        });
      }
      return newStr;
      // phone && (newStr = phone.join(','));//有值的话得到一个数组，用空格隔开转化为字符串
      // return newStr
    },
    // 点击亲属手机号
    mobilecheck(mobile) {
      let Params = { mobile: mobile };
      OrderApi.searchMobile(Params, true)
        .then(data => {
          console.log("成功返回的data", data);
          this.$message({
            message: data.msg,
            type: 'success'
          });
        })
        .catch(error => { });

    },
    // 下载e签宝合同
    xiazai(id) {
      let self = this;
      let flowId = id;
      let Params = { flowid: id };
      OrderApi.xiazai2(Params, true)
        .then(data => {
          window.open(data.data.data.data.files[0].downloadUrl, '_blank');
        })
        .catch(error => { });
    },
    // 关闭弹窗
    closeShenhe(e, f) {
      if (f == 'edit') {
        this.shenhe = e.openDialog;
        this.getData();
      }
    },
    closeShenhe2(e, f) {
      if (f == 'edit') {
        this.Ju = e.openDialog;
        this.getData();
      }
    },
    //拒绝
    showShenhe(data) {
      this.order_id = data.order_id;
      this.shenhe = true;
    },
    //提交审核
    showShenhe2(data) {

      this.order_id = data.order_id;
      this.Ju = true;
    },
    //分控备注确定
    fkbzqd() {

      let Params = {
        order_id: this.order_id,
        remarksType: 2,
        remarksText: this.inputfkbz
      }
      OrderApi.orderRemarks(Params, true)
        .then(res => {
          this.dialogVisiblefkbz = false;
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.getData();
        })
    },
    // 审核说明确定
    shsmqd() {
      let Params = {
        order_id: this.order_id,
        tuizu: this.inputshsm
      }
      OrderApi.ysunfreeze(Params, true)
        .then(res => {

          this.dialogVisibleshsm = false;
          this.getData();
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        })
    },
    //操作备注确定
    zcbzqd() {
      let Params = {
        order_id: this.order_id,
        remarksType: 1,
        remarksText: this.inputzcbz
      }
      OrderApi.orderRemarks(Params, true)
        .then(res => {

          this.dialogVisiblezcbz = false;
          this.getData();
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        })
    },
    // 操作备注弹框
    czbztk(row) {
      this.dialogVisiblezcbz = true;

      this.order_id = row.order_id;
    },

    // 分控备注弹框
    fzbztk(row) {
      this.dialogVisiblefkbz = true;
      this.order_id = row.order_id;
    },
    // 三要素确定
    sanyaoshuqd() {
      console.log(this.sysname, this.syssjh, this.syssfz);
      let Params = {
        usernum: this.syssfz,
        username: this.sysname,
        mobile: this.syssjh
      }
      OrderApi.sanyao(Params, true)
        .then(res => {
          if (res.code == 1) {
            this.$message({
              type: 'success',
              message: res.data.result.resp_msg + "," + "结果:" + res.data.result.resp_data.result_code_desc
            });
          } else {
            this.$message({
              type: 'warning',
              message: res.data.result.resp_msg + "," + "结果:" + res.data.result.resp_data.result_code_desc
            });
          }
          // self.sanyaosumsg = res.data.result.resp_msg;
          // self.sanyaosu = res.data.result.resp_data.result_code_desc;
        })
        .catch(error => { });
    },
    // 三要素
    gohuankuan(row) {
      // console.log(row,"row");
      this.dialogTableVisible = true;
      // let self = this;
      // this.$confirm('确定要查看三要素吗?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'info '
      // }).then(() => {
      //   let Params = {
      //   usernum:row.user.usernum, 
      //   username:row.user.username, 
      //   mobile:row.user.mobile
      // }
      // OrderApi.sanyao(Params, true)
      //   .then(res => {

      //     self.sanyaosumsg = res.data.result.resp_msg;
      //     self.sanyaosu = res.data.result.resp_data.result_code_desc;
      //   })
      //   .catch(error => { });
      // }).catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '已取消'
      //   });
      // });
    },
    //征信对接
    zhengxin(row) {
      let self = this;
      self.dialogTableVisible1 = true;

      let Params = {
        orderid: row.order_id
      }
      OrderApi.zhengyin(Params, true)
        .then(res => {

          self.sanyaosu = res.data.result

        })
        .catch(error => { });
    },
    handleClick() {
      alert('button click');
    },
    // 资金解冻
    gojiedong(row) {
      this.$confirm('确定要解冻?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        let data = {
          order_id: row.order_id,
        }
        OrderApi.ysunfreeze(data, true)
          .then(res => {
            this.$message({
              type: 'success',
              message: '操作成功'
            });
            this.getData();
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /*押金转租金*/
    goyajin(row) {
      this.order_id = row.order_id;
      this.dialogVisible3 = true;
    },
    /*退押金*/
    gotyj(row) {
      this.dialogVisibleshsm = true;
      this.order_id = row.order_id;
    },
    /*删除订单*/
    godelete(row) {
      this.$confirm('确定要删除订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let data = {
          order_id: row.order_id,
        }
        OrderApi.delete(data, true)
          .then(res => {
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.getData();
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 确定发货
    orderqd() {
      let self = this;
      let param = self.form;
      if (param.express_id == null) {
        this.$message.error('请选择物流公司');
        return;
      }
      if (param.express_no == '') {
        this.$message.error('请填写物流单号');
        return;
      }
      let order_id = self.order_id;
      OrderApi.delivery({
        param: param,
        order_id: order_id
      },
        true
      )
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，发货成功',
            type: 'success'
          });
          self.getData();
          self.dialogVisiblewlfh = false;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    // 订单确认发货
    gofahuo(row) {
      let self = this;
      self.dialogVisiblewlfh = true;
      const params = row.order_id;
      self.order_id = row.order_id;
      OrderApi.orderdetail({ order_id: params }, true).then(data => {
        self.expressList = data.data.expressList;
      })
        .catch(error => {
        });
    },
    //确定订单
    goque(row) {
      this.$confirm('确定要收获订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let data = {
          order_id: row.order_id,
          user_id: row.user_id,
        }
        OrderApi.receipt(data, true)
          .then(res => {
            this.$message({
              type: 'success',
              message: '确认成功'
            });
            this.getData();
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /*风控报告*/
    gofenkon(row) {
      console.log(row, "row");
      this.$confirm('确定生成百融风控报告吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        if (row.risk == '') {
          let data = {
            risk_type: 2,
            user_id: row.user.user_id
          }
          FengkongApi.riskAdd(data, true)
            .then(res => {
              let data1 = {
                risk_type: 1,
                user_id: row.user.user_id
              }
              FengkongApi.riskAdd(data1, true)
                .then(res => {
                  this.$message({
                    type: 'success',
                    message: '生成成功，正在前往~~~'
                  });
                  this.$router.push({
                    path: '/fengkong/operation/detail',
                    query: {
                      uid: row.user.user_id
                    }
                  })
                })
                .catch(error => {
                  self.loading = false;
                });
            })
            .catch(error => {
              self.loading = false;
            });
        } else {
          this.$router.push({
            path: '/fengkong/operation/detail',
            query: {
              uid: row.user.user_id
            }
          })
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /*签署蚂蚁链代扣*/
    gomayi(row) {
      this.$confirm('确定签署蚂蚁链代扣吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let data = {
          order_id: row.order_id
        }
        FengkongApi.chuangjianhetong(data, true)
          .then(res => {
            this.$message({
              type: 'success',
              message: '生成成功,请前往订单详情查看~~~'
            });
            // this.$router.push({
            //   path: '/fengkong/operation/detail',
            //   query: {
            //     uid: row.user.user_id
            //   }
            // })
          })
          .catch(error => {
            self.loading = false;
          });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    //风险命中查询
    fxmzcx(row) {
      let username = row.username
      let usernum = row.usernum
      let mobile = row.user.mobile
      let fengxian = ''
      this.fengxianchaxun = true;
      axios.post('https://blacklist.jiulove.cn/api.php?key=474e6bb3e64d2e670744ab7fd1ee2e16&phone=' + mobile + '&idcard=' + usernum + '&realname=' + username, {})
        .then(response => {
          if (response.url == '') {
            fengxian = '暂无命中'
          } else {
            fengxian = '命中'
          }
          this.fengxian = fengxian
          return;
          resolve(response)
        })
        .catch((error) => {
          console.log(error);
          return;
          reject(error);
        })

    },

    /*弹窗确定*/
    queding1() {
      let Params = {
        order_id: this.order_id,
        yushou: this.yushou
      }
      OrderApi.yushou(Params, true)
        .then(res => {
          this.dialogVisible1 = false;
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        })
    },
    queding2() {
      let Params = {
        order_id: this.order_id,
        money: this.zujin
      }
      OrderApi.zhuanzujin(Params, true)
        .then(res => {
          this.dialogVisible3 = false;
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        })
    },
    /*操作备注弹窗确定*/
    queding4() {
      let Params = {
        order_id: this.order_id,
        remarksType: 1,
        remarksText: this.remarksText
      }
      OrderApi.orderRemarks(Params, true)
        .then(res => {
          this.dialogVisible4 = false;
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        })
    },
    /*风控备注弹窗确定*/
    queding5() {
      let self = this;
      let Params = {
        order_id: self.order_id,
        remarksType: 2,
        remarksText: self.remarksText1
      }
      OrderApi.orderRemarks(Params, true)
        .then(res => {
          self.getData();
          self.dialogVisible5 = false;
          self.$message({
            message: '操作成功',
            type: 'success'
          });
        })
    },
    /*预交租金*/
    goyujiao(row) {
      this.dialogVisible1 = true;
      this.order_id = row.order_id;
      var str = row.product[0].product_attr;
      if (str.indexOf("碎屏换新") != -1) {
        this.radio = "1";
      } else {
        this.radio = "2";
      }
    },
    /*操作备注*/
    gocaozuo(row) {
      this.dialogVisible4 = true;
      this.order_id = row.order_id;
    },
    /*风控备注*/
    gofengkong(row) {
      this.dialogVisible5 = true;
      this.order_id = row.order_id;
    },
    /*提交租期*/
    gozujin(row) {
      // console.log("======", row);
      this.dialogVisible = true;
      let Params = {
        order_id: row.order_id,
      }
      OrderApi.billinfo(Params, true)
        .then(res => {
          console.log("res", res);
          this.zqlist = res.data.list;
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    /*关闭确认*/
    handleClose() {
      this.dialogVisible = false;
    },
    /*关闭确认*/
    handleClose1() {
      this.dialogVisible1 = false;
    },
    handleClose2() {
      this.dialogVisible2 = false;
    },
    handleClose3() {
      this.dialogVisible3 = false;
    },
    handleClose4() {
      this.dialogVisible4 = false;
    },
    handleClose5() {
      this.dialogVisible5 = false;
    },
    /*手动扣款弹窗确定*/
    sdqd() {
      console.log(this.sdinput);
      OrderApi.checkpwd({
        password: this.sdinput
      }, true).then(data => {
        console.log(data, "成功");
        if (data.msg == "操作成功") {
          this.dialogVisible10 = false;
          console.log(this.shneheList);
          if (this.shneheList.length <= 0) {
            this.$message({
              message: '请选择归还期数',
              type: 'error'
            });
            return;
          }
          OrderApi.toExamine({
            billid: this.shneheList
          }, true).then(data => {
            this.dialogVisible = false;
            console.log(data, "成功");
            this.$message({
              message: '操作成功',
              type: 'success'
            });
          })
        } else {
          this.$message.error('操作失败');
        }
      })
    },
    queding() {
      this.dialogVisible10 = true;
    },
    // 申请上报
    submission(row) {
      console.log(row.order_id, "申请上报");
      this.$confirm('确定要申请上报?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let Params = {
          orderid: row.order_id,
        }
        OrderApi.testBooleanDemo(Params, true)
          .then(res => {
            this.getData();
            this.$message({
              message: '操作成功',
              type: 'success'
            });
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 放款报送
    Loan(row) {
      console.log(row.order_id, "放款报送");
      this.$confirm('确定要放款报送?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let Params = {
          order_id: row.order_id,
        }
        OrderApi.fkbs(Params, true)
          .then(res => {
            this.getData();
            this.$message({
              message: '操作成功',
              type: 'success'
            });
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /*签订合同*/
    goheton(row) {
      this.$confirm('确定要生成合同?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(() => {
        let Params = {
          order_id: row.order_id,
        }
        OrderApi.contract(Params, true)
          .then(res => {
            this.getData();
            this.$message({
              message: '操作成功',
              type: 'success'
            });
          })
          .catch(error => {
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 结清
    jieqing(row) {
      this.order_id = row.order_id;
      this.dialogVisiblejq = true;
    },
    // 结清确定
    orderjq() {
      let Params = {
        order_id: this.order_id,
        money: this.jqform.value,
        type: this.jqform.type
      }
      OrderApi.jieqing(Params, true)
        .then(res => {
          this.getData();
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        })
        .catch(error => {
        });
    },
    /*去签署*/
    goqianshu(row) {
      this.folwid = row.folwid;
      this.shop_url = row.shop_url;
      if (!row.folwid) {
        this.$message({
          message: '请先操作生成合同',
          type: 'warning'
        });
      } else {
        this.dialogVisible2 = true;
        OrderApi.FlowDetail({
          flowId: row.folwid
        }, true).then(data => {
          this.htdata = data;
          this.getData();
        })
      }
    },
    // 跳转合同链接
    goshowurl() {
      open(this.shop_url)
    },
    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    // 获取分类
    getFenlei() {
      let self = this;
      PorductApi.catList({}, true)
        .then(data => {
          self.loading = false;
          self.catList = data.data.list;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      let newparam = [];
      newparam.search = Params.search
      newparam.order_no = Params.order_no
      newparam.style_id = Params.style_id
      newparam.create_time = Params.create_time
      newparam.dataType = self.activeName;
      newparam.page = self.curPage;
      newparam.list_rows = self.pageSize;
      if (this.baseInfo.user.shop_user_id == 10001 || this.baseInfo.user.shop_user_id == 10009 || this.baseInfo.user.shop_user_id == 10010) {
        newparam.tuiguang_id = Params.tuiguang_id
      }
      self.loading = true;
      OrderApi.tgorderlist(newparam, true)
        .then(res => {
          self.tableData2.data = res.data.list.data;
          let list = [];
          let tuikuanzhauntai = '成功';
          for (let i = 0; i < res.data.list.data.length; i++) {
            let pricezq = 0;
            let item = res.data.list.data[i];
            item.remarks_risk = self.remarksSj(item.remarks_risk);
            if (item.remarks_risk == '') {
              item.remarks_risk = '风控备注：暂无'
            } else {
              item.remarks_risk = '风控备注：<br/> ' + item.remarks_risk
            }

            if (item.yj_fail_msg == '' && item.ys_fail_msg == '') {
              if (item.order_status.value == '40' || item.order_status.value == '20') {
                item.tuikuanzhauntai = '成功'
              } else {
                item.tuikuanzhauntai = '';
              }

            } else {
              item.tuikuanzhauntai = '失败';
            }

            let xing = item.ant_shield;
            if (xing == '') {
              item.ant_shield = '未生成'
            } else {
              let xing1 = JSON.parse(xing)
              item.ant_shield = xing1.models[0].score
            }
            let ze = item.credit_report
            if (ze == '') {
              item.credit_report = '未生成'
              item.cancel_remark = '未生成'
            } else {
              let ze1 = JSON.parse(ze)
              item.credit_report = ze1.resp_data.score_norm_explain
              item.cancel_remark = ze1.resp_data.verify_recomment
            }
            // console.log(item.order_bill)
            item.order_bill.forEach(data => {
              if (data.is_pay_status == 1) {
                pricezq = Number(pricezq) + Number(data.price);
              }
            });
            item.pricezq = pricezq.toFixed(2);
            let topitem = {
              order_no: item.order_no,
              create_time: item.create_time,
              order_source: item.order_source,
              order_source_text: item.order_source_text,
              is_top_row: true,
              order_status: item.order_status.value,
            };
            list.push(topitem);
            if (item.is_yushou != 2) {
              item.yushou = 0;
            }
            var edeposit = item.deposit;
            var zhuanzujinData = item.zhuanzujin;
            var nbop = item.new_buy_out_price;
            if (item.auth_no == '') {
              edeposit = 0;
            }
            if (item.maiduan_no == '') {
              nbop = 0;
            }

            item.yujyj = (Number(item.yushou) + Number(edeposit) + Number(zhuanzujinData)).toFixed(2);
            // item.pricezq = pricezq.toFixed(2);
            item.yijiao = (Number(item.yujyj) + Number(pricezq) + Number(zhuanzujinData) + Number(nbop)).toFixed(2);
            item.ysqyjze = (Number(zhuanzujinData) + Number(edeposit)).toFixed(2);
            item.total_price = (Number(item.total_price) - Number(item.deposit) - Number(zhuanzujinData)).toFixed(2);

            list.push(item);
            // if (item.lease_type == 1) {
            //   item.lease_type = '租满即送'
            // } else if (item.lease_type == 2) {
            //   item.lease_type = '租完买断'
            // }
            // item.lease_type = item.lease_type;
          }
          self.tableData.data = list;
          self.totalDataNumber = res.data.list.total;
          self.exStyle = res.data.ex_style;
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch(error => { });
    },

    // 修改商品
    goeditsp(row) {
      this.dialogVisiblexgsp = true;
      console.log(row);
      this.order_id = row.order_id;
      this.shrdh = row.user.mobile;
      this.shr = row.user.username;
      this.prData = row.product[0];
    },

    selectSP(e) {
      // console.log(e);
      this.spflvalue = e;
      console.log("spflvalue", this.spflvalue);
      for (let var1 of this.catList) {
        if (var1.category_id == e) {
          // console.log(var1);
          this.catList2 = var1.child;
        }
      }
    },

    selectSP2(e) {
      // console.log(e);
      this.sxspvalue = e;
      console.log("sxspvalue", this.sxspvalue);
      let self = this;
      PorductApi.productList({
        category_id: e,
        page: 1,
        list_rows: 10
      }, true)
        .then(data => {
          self.loading = false;
          self.catList3 = data.data.list.data;
        })
        .catch(error => {
          self.loading = false;
        });

    },

    selectSP3(e) {
      // console.log(e);
      this.sxggvalue = e;
      console.log("sxggvalue", this.sxggvalue);
      let self = this;
      PorductApi.getEditData({
        product_id: e,
      },
        true
      )
        .then(res => {
          // console.log(res,"kkkk");
          this.catList4 = res.data.model.sku;
          this.catList5 = res.data.specData.spec_attr;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    selectSP4(e) {
      // console.log(e);
      this.spggvalue = e;
      console.log("spggvalue", this.spggvalue);
    },

    selectSP5(e, name, index) {
      // console.log(e);
      switch (index) {
        case 0:
          this.Attrvalue = e;
          this.ggname = name;
          // console.log("值：", this.Attrvalue,name,index);
          break;
        case 1:
          this.Attrvalue2 = e;
          this.ggname2 = name;
          // console.log("值：", this.Attrvalue1,name,index);
          break;
        case 2:
          this.Attrvalue3 = e;
          this.ggname3 = name;
          // console.log("值：", this.Attrvalue2,name,index);
          break;
        case 3:
          this.Attrvalue4 = e;
          this.ggname4 = name;
          if (name == "租完买断") {
            this.lease_type = 2
          } else {
            this.lease_type = 1
          }
          // console.log("值：", this.Attrvalue3,name,index);
          break;
        case 4:
          this.Attrvalue5 = e;
          this.ggname5 = name;
          // console.log("值：", this.Attrvalue4,name,index);
          // console.log("sku_id:",this.Attrvalue + "_" +this.Attrvalue2 + "_" +this.Attrvalue3 + "_" +this.Attrvalue4 + "_" +this.Attrvalue5);
          this.sku_iddata = this.Attrvalue + "_" + this.Attrvalue2 + "_" + this.Attrvalue3 + "_" + this.Attrvalue4 + "_" + this.Attrvalue5;
          break;
      }


      for (let data of this.catList5) {
        for (let item of data.spec_items) {
          if (item.item_id == this.Attrvalue) {
            // console.log("spec_value",item.spec_value);
            var ncval = item.spec_value;
          }
          if (item.item_id == this.Attrvalue2) {
            // console.log("spec_value",item.spec_value);
            var ysval = item.spec_value;
          }
          if (item.item_id == this.Attrvalue3) {
            // console.log("spec_value",item.spec_value);
            var csval = item.spec_value;
          }
          if (item.item_id == this.Attrvalue4) {
            // console.log("spec_value",item.spec_value);
            var tcval = item.spec_value;
          }
          if (item.item_id == this.Attrvalue5) {
            // console.log("spec_value",item.spec_value);
            var bzval = item.spec_value;
            // console.log("product_attr:",this.ggname+":"+ncval +";" + this.ggname2+":"+ysval+";"
            //  +this.ggname3+":"+csval+";" + this.ggname4+":"+tcval+";" +this.ggname5+":"+bzval+";");
            this.product_attrdata = this.ggname + ":" + ncval + ";" + this.ggname2 + ":" + ysval + ";"
              + this.ggname3 + ":" + csval + ";" + this.ggname4 + ":" + tcval + ";" + this.ggname5 + ":" + bzval + ";"
          }
        }
      }

    },

    // 修改商品确定
    xgspqd() {
      // console.log("order_id", this.order_id);
      // console.log("product_id", this.sxggvalue);
      // console.log("sku_id", this.sku_iddata);
      // console.log("product_attr", this.product_attrdata);
      // return
      let self = this;
      OrderApi.checkproduct({
        order_id: self.order_id,
        product_id: self.sxggvalue,
        sku_id: self.sku_iddata,
        product_attr: self.product_attrdata,
        lease_type: self.lease_type
      }, true)
        .then(data => {
          // console.log("data", data);
          self.$message({
            message: data.msg,
            type: 'success'
          });
          self.dialogVisiblexgsp = false;
          self.getData();
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*订单详情*/
    addClick(row) {
      let self = this;
      let params = row.order_id;
      // self.$router.push({
      //   path: '/order/order/Detail',
      //   query: {
      //     order_id: params
      //   }
      // });
      let routeData = self.$router.resolve({ path: '/order/order/Detail', query: { order_id: params } });
      window.open(routeData.href, '_blank');
    },
    getLogistics(row) {
      let self = this;
      let Params = {
        order_id: row.order_id,
      }
      self.loading = true;
      OrderApi.queryLogistics(Params, true)
        .then(res => {
          self.logisticsData = res.data.express.list;
          self.loading = false;
          self.openLogistics()
        })
        .catch(error => {
          self.loading = false;
        });
    },
    openLogistics() {
      this.isLogistics = true;
    },
    closeLogistics() {
      this.isLogistics = false;
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    onExport: function () {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/order.operate/export?' + qs.stringify(this.searchForm);
    }
  },
  filters: {
    // 过滤器
    formatDate(value) {
      let date = new Date(value * 1000);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d; //天补0
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s; //秒补0
      return y + '-' + MM + '-' + d; //年月日
      // return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s; //年月日时分秒
    },
    // 身份证换算成年龄
    getsfz(iden) {
      let val = iden.length;
      let myDate = new Date();
      let month = myDate.getMonth() + 1;
      let day = myDate.getDate();
      let age = 0;

      if (val === 18) {
        age = myDate.getFullYear() - iden.substring(6, 10) - 1;

        if (iden.substring(10, 12) < month || iden.substring(10, 12) == month && iden.substring(12, 14) <= day) age++;

      }
      if (val === 15) {
        age = myDate.getFullYear() - iden.substring(6, 8) - 1901;

        if (iden.substring(8, 10) < month || iden.substring(8, 10) == month && iden.substring(10, 12) <= day) age++;
      }
      return age
      // this.age = age;

    }
  },
};
</script>
<style lang="scss">
.mr {
  margin: 20px 30px;
}

.fwbold {
  font-weight: bold;
  font-size: 13px;
}

.d1 {
  width: 100px;
  list-style: none;
  border: 1px solid #FFA49F;
  padding: 5px;
  background-color: #FFF1F0;
  color: #F6363E;
  border-radius: 10px;
  text-align: center;
  margin: 25px 0;
}

.anniu {
  margin-bottom: 3px;
}

.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}

.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}

.order-code .state-text-red {
  background: red;
}

.table-wrap .product-info:first-of-type {
  border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}

.xiegang {
  color: #18BC9C;
  margin: 0 5px;
}

.xxflex {
  display: flex;
}

.juz {
  // display: flex;
  // flex-direction:column;
  // justify-content:center;
  // align-items:center;
  white-space: normal;
  color: #39cccc;
}

.juz2 {
  // display: flex;
  // flex-direction:column;
  // justify-content:center;
  // align-items:center;
  white-space: normal;
  color: #E74C3C;
}

.el-dropdown {
  vertical-align: top;
}

.el-dropdown+.el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.sanyaosu {
  text-align: center;
  font-size: 20px;
  margin: 10px;
}

.qianshu {
  font-size: 20px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/order/received/tgindex.vue